<template>
  <div>
    <el-dialog append-to-body title="对公转账详情"
                :visible.sync="dialogVisible"
                width="900"
                :before-close="handleClose">
      <div class="transfer-box">
        <div class="transfer-title">转账信息 <span class="transfer-explain">转账成功半小时内，系统自动为你开通会员,若未开通会员，请联系客服处理</span></div>
        <div class="transfer-detail">
          <div class="transfer-item">
            <span class="item-title">转账金额:</span>
            <span class="item-content">￥{{detail.orderMoney}}</span>
          </div>
          <div  class="transfer-item">
            <span class="item-title">收款公司名称:</span>
            <span class="item-content">{{detail.receivePaymentName}}</span>
          </div>
          <div class="transfer-item">
            <span class="item-title">收款账户:</span>
            <span  class="item-content">{{detail.receivePaymentAccount}}</span>
            <div style="margin-left: 100px;color: rgba(30, 32, 35, .65);">
              (每笔订单对应不同25位收款账号，请勿重复打款)
            </div>
          </div>

          <div class="transfer-item">
            <span class="item-title">开户行名称:</span>
            <span class="item-content">{{detail.openingBankName}}</span>
          </div>
        </div>
        <div style="text-align: right"><el-button @click="handleCopy" class="copy-btn">复制转账信息</el-button></div>
      </div>
      <div class="order-box">
        <div class="order-detail">订单明细</div>

          <div class="order-item"><span>{{detail.productName}}</span>
          <span style="margin-left: 12px;">到期时间{{detail.expireDate}}</span>
            <div style="flex: 1 1;text-align: end;font-weight: 500">￥{{detail.orderMoney}}</div>
          </div>

        <div class="order-pay">应付金额<span style="color:#FF1200;">￥</span><span style="font-size: 32px;color:#FF1200;">{{detail.orderMoney}}</span></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props:{
    dialogVisible:Boolean,
    detail:Object,
  },
  data(){
    return{

    }
  },
  methods:{
    handleClose(){
      this.$emit('cancel')
    },
    handleCopy(){
      const text=`转账金额：¥${this.detail.orderMoney}\n` +
        `收款公司名称：${this.detail.receivePaymentName}\n` +
        `收款账户：${this.detail.receivePaymentAccount}\n` +
        `开户行名称 ${this.detail.openingBankName}`

      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 尝试执行复制操作
        const success = document.execCommand('copy');
        if (success) {
          this.$message.success('复制成功！')
          // createMessage.success('复制成功');
        } else {
          this.$message.success('复制失败！')
          // createMessage.error('复制失败');
        }
      } catch (error) {
        this.$message.success(`复制失败:${error}`)
        // createMessage.error('复制失败:', error);
      }

      document.body.removeChild(textarea);

      // navigator.clipboard.writeText()
      //     .then(() => {
      //       this.$message.success('复制成功！')
      //       console.log("Text copied to clipboard");
      //     })
      //     .catch((error) => {
      //       console.error("Failed to copy text: ", error);
      //     });

    }
  }
}
</script>
<style scoped>
.dialog-bg{
  background: rgba(0,0,0,0.5)
}
/deep/ .el-dialog{
  background:#ffffff;
}
/deep/ .el-dialog__body{
  background:#f7f9fa;
  padding:20px;
}
.transfer-box{
  background:#fff;
  border-radius: 12px;
  margin:0 auto 24px;
  width: 678px;
  padding:24px;
}
.transfer-title{
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.transfer-explain{
  font-size: 14px;
  font-weight: 400;
  color: rgba(30, 32, 35, .45);
  margin-left: 12px;
}
.transfer-detail{
  background: #f7f9fa;
  border-radius: 8px;
  margin: 12px 0;
  padding: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
}
.transfer-item{

}
.item-title{
  display: inline-block;
  width: 100px;
}
.copy-btn{
  margin-bottom: 6px;
  background:linear-gradient(91deg,#FD6B00,#FF063C);
  color: #ffffff;
  font-size: 18px;
  width: 200px;
  height: 48px;
  border-radius: 12px;

}
.order-box{
  margin: 0 auto 24px;
  width: 678px;
  padding: 24px;
  border-radius: 12px;
  background-color: #fff;
}
.order-detail{
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;
}
.order-item{
  display: flex;
  font-size: 12px;
  margin: 12px 0;
}
.order-pay{
  font-size: 16px;
  color: rgba(30, 32, 35, .65);
  text-align: end;
  padding-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/accept/purchase-membership/public-transfer.vue